<template>
  <div
    class="ToolTip"
    @click.stop
    @[enterEvent]="ui.showElement = true"
    @[leaveEvent]="ui.showElement = false"
  >
    <slot name="trigger">
      <span class="Icon Icon-ellipsis-h" />
    </slot>
    <div
      v-if="ui.showElement"
      :class="['Tooltip-content', position]"
    >
      <slot name="tip">
        <p>Tip</p>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    position: {
      type: String,
      default: 'top center',
    },
    isClickable: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      ui: {
        showElement: false,
      },
    };
  },

  computed: {
    leaveEvent() {
      return this.isClickable ? 'mouseleave' : 'mouseout';
    },
    enterEvent() {
      return this.isClickable ? 'click' : 'mouseover';
    },
  },
};
</script>
<style lang="scss" scoped>

  .slide-fade-enter-active {
    transition: all .3s ease;
  }

  .slide-fade-leave-active {
    transition: all .2s ease;
  }

  .slide-fade-enter {
    opacity: 0;
    transform: translateY(-20px) scale(0);
  }

  .slide-fade-leave-to {
    opacity: 0;
    transform: translateY(-20px) scale(0);
  }

  .Tooltip-content {
    width: auto;
    min-width: 150px;
  }

  .ToolTip {
    display: inline-block;
    position: relative;
  }

  // Tooltip Content
  .Tooltip-content {
    width: auto;
    bottom: 100%;
    border-radius: 6px;
    position: absolute;
    color: #fff;
    padding: 8px;
    background: rgba(0, 0, 0, 0.8);
    text-wrap: none;
    word-break: normal;
    font-size: 13px;
    line-height: normal;
    * {
      color: #fff;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  /* POSITIONING */
  .center {
    left: 50%;
    transform: translateX(-50%);
  }

  .top {
    bottom: 100%;
    margin-bottom: 8px;
    &:after{
      content: '';
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      width: 0px;
      height: 0px;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-top: 6px solid rgba(0, 0, 0, 0.8);;
    }
  }

  .bottom {
    top: 100%;
    margin-top: 8px;
    bottom: auto;
    &:after{
      content: '';
      position: absolute;
      bottom: 100%;
      left: 50%;
      transform: translateX(-50%);
      width: 0px;
      height: 0px;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-bottom: 6px solid rgba(0, 0, 0, 0.8);;
    }
  }

  .left {
    left: auto;
    right: 100%;
    bottom: auto;
    margin-right: 8px;
    &.center {
      left: auto;
    }
    &:after{
      content: '';
      position: absolute;
      left: 100%;
      top: 50%;
      transform: translateY(-50%);
      width: 0px;
      height: 0px;
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;
      border-left: 6px solid rgba(0, 0, 0, 0.8);;
    }
  }

  .right {
    right: auto;
    left: 100%;
    bottom: auto;
    margin-left: 8px;
    &.center {
      right: auto;
    }
    &:after{
      content: '';
      position: absolute;
      right: 100%;
      top: 50%;
      transform: translateY(-50%);
      width: 0px;
      height: 0px;
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;
      border-right: 6px solid rgba(0, 0, 0, 0.8);;
    }
  }
  .left,.right{
    &.center {
      top: 50%;
      transform: translateY(-50%);
    }
  }
</style>
